export default __webpack_public_path__ + "static/vevol-media-og-image-81e40bd0fc7ec98532141cc426d18d4d.jpg";